var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeMax = function SvgVolumeMax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 9c.628.836 1 1.874 1 3a4.98 4.98 0 0 1-1 3m2-9.708A8.98 8.98 0 0 1 21 12a8.98 8.98 0 0 1-3 6.708M4.6 9h.901c.551 0 .827 0 1.082-.069a2 2 0 0 0 .631-.295c.216-.152.393-.364.746-.787l2.625-3.151c.436-.523.654-.785.844-.812a.5.5 0 0 1 .442.16C12 4.19 12 4.53 12 5.21v13.58c0 .681 0 1.021-.129 1.164a.5.5 0 0 1-.442.16c-.19-.027-.408-.289-.844-.811L7.96 16.15c-.353-.423-.53-.634-.746-.787a2 2 0 0 0-.631-.295C6.328 15 6.053 15 5.5 15h-.9c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 14.24 3 13.96 3 13.4v-2.8c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C3.76 9 4.04 9 4.6 9"
  })));
};
export default SvgVolumeMax;